import React from "react";

/**
 * AiMedley logo — 4 overlapping color drops representing the 4 model "minds"
 * blending into one workbench. Uses mix-blend-mode for the gorgeous mid-tones.
 *
 * Props:
 *   size       — pixel size of the mark (default 40)
 *   wordmark   — "full" | "compact" | "none"  (default "full")
 *   tagline    — show small uppercase tagline under wordmark
 *   className  — extra wrapper classes
 */
export default function Logo({ size = 40, wordmark = "full", tagline = false, className = "" }) {
  const mark = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
      aria-label="AiMedley logo"
      role="img"
    >
      {/* black neo-brutalist plate behind the mark */}
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#FDF8F5" stroke="#0F172A" strokeWidth="3" />

      {/* 4 overlapping colored drops — mix-blend creates the medley */}
      <g style={{ mixBlendMode: "multiply" }} transform="translate(32 33)">
        {/* DeepSeek — top */}
        <circle cx="0" cy="-9" r="13" fill="#3B82F6" opacity="0.9" />
        {/* Qwen — right */}
        <circle cx="9" cy="2" r="13" fill="#EF4444" opacity="0.9" />
        {/* Kimi — bottom */}
        <circle cx="0" cy="11" r="13" fill="#10B981" opacity="0.9" />
        {/* Llama — left */}
        <circle cx="-9" cy="2" r="13" fill="#F59E0B" opacity="0.9" />
      </g>

      {/* small spark in the center for delight */}
      <circle cx="32" cy="33" r="2.5" fill="#0F172A" />
    </svg>
  );

  if (wordmark === "none") return <span className={className}>{mark}</span>;

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {mark}
      <div className="leading-none">
        <div className="font-heading font-bold tracking-tight" style={{ fontSize: Math.max(16, size * 0.45) }}>
          <span>Ai</span>
          <span className="text-slate-900">Medley</span>
        </div>
        {tagline && (
          <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-bold mt-1">
            Multi-model workbench
          </div>
        )}
      </div>
    </div>
  );
}
